/**
 * Campagnes VtM côté MJ (API Firestore modulaire). Archiver = `active: false`, comme pour Aria.
 */
import {getFirestore, doc, updateDoc, serverTimestamp} from 'firebase/firestore';

export const updateCampaign = (uid, fields) => updateDoc(doc(getFirestore(), 'campaigns', uid), {
  ...fields,
  lastUpdateAt: serverTimestamp(),
});
